// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-notification-excel {
  overflow: hidden;
  height: 100vh;
}
.create-notification-excel .create-notification-excel-content {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.create-notification-excel .sidebar {
  height: 100vh;
}
.create-notification-excel .create-notification-excel-section {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
}
.create-notification-excel .create-notification-excel-section::-webkit-scrollbar {
  width: 0px;
}
.create-notification-excel .create-notification-excel-section::-webkit-scrollbar-thumb {
  background: transparent;
}
.create-notification-excel .create-notification-excel-section {
  scrollbar-width: none;
}
.create-notification-excel .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.create-notification-excel .create-notification-excel-text {
  font-family: "Nunito", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.create-notification-excel .create-notification-excel-form {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  margin: auto;
}
.create-notification-excel .create-notification-heading {
  width: 97%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.create-notification-excel .notification-excel-form {
  width: 100%;
}
.create-notification-excel .notification-excel-form .download-template {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 30px;
}
.create-notification-excel .notification-excel-form .download-template .form-group-excel {
  display: flex;
  align-items: center;
  width: 45%;
  gap: 10px;
  position: relative;
}
.create-notification-excel .notification-excel-form .download-template .form-group-excel .notification-excel-label {
  position: absolute;
  top: -10px;
  left: 15px;
}
.create-notification-excel .notification-excel-form .download-template .form-group-excel .select-excel-template-criteria {
  outline: none;
  width: 100%;
  height: 40px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.create-notification-excel .notification-excel-form .download-template .choose-file-button {
  display: flex;
  align-items: center;
  height: 40px;
  white-space: nowrap;
}
.create-notification-excel .notification-excel-form .download-template .choose-file-button .custom-file-upload {
  color: #0C3688;
  border: 1px solid #0C3688;
  padding: 8px 36px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  position: inherit;
  height: 40px;
}
.create-notification-excel .notification-excel-form .form-group-excel-description {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 30px;
  position: relative;
}
.create-notification-excel .notification-excel-form .form-group-excel-description .notification-excel-description-label {
  position: absolute;
  top: -10px;
  left: 15px;
}
.create-notification-excel .notification-excel-form .form-group-excel-description .notification-excel-description-textarea {
  width: 93%;
  height: 89px;
  border-radius: 5px;
  outline: none;
  border: 1px solid #A3AEC4;
  padding: 8px;
}
.create-notification-excel .notification-excel-form .button-group {
  margin: 40px 0px;
  display: flex;
  gap: 10px;
}
.create-notification-excel .notification-excel-form .button-group button {
  width: 128px;
  height: 32px;
  border-radius: 5px;
  background: white;
}
.create-notification-excel .notification-excel-form .button-group .close-btn {
  border: 1px solid #0C3688;
}
.create-notification-excel .notification-excel-form .button-group .send-btn {
  background-color: #0C3688;
  color: white;
}
.create-notification-excel .notification-excel-form .button-group .send-btn:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.create-notification-excel .notification-excel-form .button-group .loader-btn {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .form-group-excel {
    display: flex;
    align-items: center;
    width: 100% !important;
    gap: 10px;
    position: relative;
  }
  .create-notification-excel .notification-excel-form .download-template {
    flex-wrap: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/CreateBulkNotification/CreateEditBulkNotification.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;EACA,gBAAA;AACR;AAEI;EACI,aAAA;AAAR;AAGI;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AADR;AAGQ;EACI,UAAA;AADZ;AAIQ;EACI,uBAAA;AAFZ;AAKQ;EACI,qBAAA;AAHZ;AAOI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AALR;AAQI;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AANR;AASI;EACI,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAPR;AAUI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AARR;AAWI;EACI,WAAA;AATR;AAWQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AATZ;AAWY;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAThB;AAWgB;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AATpB;AAYgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAVpB;AAcY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAZhB;AAcgB;EACI,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAZpB;AAmBQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAjBZ;AAmBY;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AAjBhB;AAoBY;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;AAlBhB;AAsBQ;EACI,gBAAA;EACA,aAAA;EACA,SAAA;AApBZ;AAsBY;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AApBhB;AAuBY;EACI,yBAAA;AArBhB;AAwBY;EACI,yBAAA;EACA,YAAA;AAtBhB;AAwBgB;EACI,mEAAA;AAtBpB;AA0BY;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;AAxBhB;AA2Bc;EACE;IAAK,uBAAA;EAxBnB;EAyBc;IAAO,yBAAA;EAtBrB;AACF;;AA2BA;EACI;IACI,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,kBAAA;EAxBN;EA2BE;IACI,iBAAA;EAzBN;AACF","sourcesContent":[".create-notification-excel {\n    overflow: hidden;\n    height: 100vh;\n\n    .create-notification-excel-content {\n        display: flex;\n        width: 100%;\n        overflow: hidden;\n    }\n\n    .sidebar {\n        height: 100vh;\n    }\n\n    .create-notification-excel-section {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n\n        &::-webkit-scrollbar {\n            width: 0px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: transparent;\n        }\n\n        & {\n            scrollbar-width: none;\n        }\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n    }\n\n    .create-notification-excel-text {\n        font-family: \"Nunito\", sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        color: #2D2D2D;\n        padding: 0.5rem;\n    }\n\n    .create-notification-excel-form {\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n        padding: 20px;\n        border-radius: 8px;\n        width: 100%;\n        margin: auto;\n    }\n\n    .create-notification-heading {\n        width: 97%;\n        margin: auto;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .notification-excel-form {\n        width: 100%;\n\n        .download-template {\n            display: flex;\n            align-items: center;\n            flex-wrap: wrap;\n            gap: 30px;\n            margin-top: 30px;\n\n            .form-group-excel {\n                display: flex;\n                align-items: center;\n                width: 45%;\n                gap: 10px;\n                position: relative;\n\n                .notification-excel-label {\n                    position: absolute;\n                    top: -10px;\n                    left: 15px;\n                }\n\n                .select-excel-template-criteria {\n                    outline: none;\n                    width: 100%;\n                    height: 40px;\n                    padding: 5px;\n                    border: 1px solid #ccc;\n                    border-radius: 4px;\n                }\n            }\n\n            .choose-file-button {\n                display: flex;\n                align-items: center;\n                height: 40px;\n                white-space: nowrap;\n\n                .custom-file-upload {\n                    color: #0C3688;\n                    border: 1px solid #0C3688;\n                    padding: 8px 36px;\n                    border-radius: 5px;\n                    cursor: pointer;\n                    font-size: 14px;\n                    font-weight: 500;\n                    text-align: center;\n                    position: inherit;\n                    height: 40px;\n                }\n            }\n\n\n        }\n\n        .form-group-excel-description {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            margin-top: 30px;\n            position: relative;\n\n            .notification-excel-description-label {\n                position: absolute;\n                top: -10px;\n                left: 15px;\n            }\n\n            .notification-excel-description-textarea {\n                width: 93%;\n                height: 89px;\n                border-radius: 5px;\n                outline: none;\n                border: 1px solid #A3AEC4;\n                padding: 8px;\n            }\n        }\n\n        .button-group {\n            margin: 40px 0px;\n            display: flex;\n            gap: 10px;\n\n            button {\n                width: 128px;\n                height: 32px;\n                border-radius: 5px;\n                background: white;\n            }\n\n            .close-btn {\n                border: 1px solid #0C3688;\n            }\n\n            .send-btn {\n                background-color: #0C3688;\n                color: white;\n\n                &:disabled{\n                    background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n                }\n            }\n\n            .loader-btn {\n                border: 3px solid #f3f3f3;\n                border-top: 3px solid #3498db;\n                border-radius: 50%;\n                width: 18px;\n                height: 18px;\n                animation: spin 1s linear infinite;\n                display: inline-block;\n                vertical-align: middle;\n              }\n              \n              @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n              }\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .form-group-excel {\n        display: flex;\n        align-items: center;\n        width: 100% !important;\n        gap: 10px;\n        position: relative;\n    }\n\n    .create-notification-excel .notification-excel-form .download-template {\n        flex-wrap: nowrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
